export const projects = [
//   {
//     id: 1,
//     title: "E-Commerce Platform",
//     description: "Full-stack e-commerce solution with React, Node.js, and MongoDB. Features include user authentication, payment integration, and admin dashboard.",
//     image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=600&fit=crop",
//     tags: ["React", "Node.js", "MongoDB", "Stripe"],
//     category: "web-development",
//     liveLink: "https://demo-ecommerce.com",
//     githubLink: "https://github.com/username/ecommerce-platform"
//   },
];

export const categories = [
  { id: "all", name: "All Projects" },
  { id: "web-development", name: "Web Development" },
  { id: "devops", name: "DevOps" },
];
